import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage4UpHedsOnlyIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryPackage4UpHedsOnlyIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
